import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import {
  ExtraPrice,
  ExtraTitle,
  RowContainer,
  ExtraDetailsContainer,
  ExtraTitleContainer,
} from '../styled';
import { formatPrice } from '@/utils/formatter';
import Checkbox from '../../../../../../components/Checkbox';
import { IconButton } from '../../styled';
import ExtraEditModal from './ExtraEditModal';
import { removeExtraFromGroup as removeExtraFromGroupMutation } from '../../../../../../graphql/mutations';
import { productCategories as productCategoriesQuery } from '../../../../../../graphql/queries';
import i18n from '@/utils/i18n';

function ExtraSelectItem({
  extra,
  group,
  disabled,
  selected,
  onChange,
  productId,
  storeId,
}) {
  const [isEditModalOpen, toggleEditModal] = useState(false);
  const [removeExtraFromGroup] = useMutation(removeExtraFromGroupMutation);

  function onExtraChange() {
    if (!disabled) onChange(extra, group);
  }

  function openEditModal(e) {
    e.stopPropagation();
    toggleEditModal(true);
  }

  function closeEditModal() {
    toggleEditModal(false);
  }

  async function removeProduct(e) {
    e.stopPropagation();
    const removable = window.confirm(
      i18n.t('Menu:removeExtraConfirmation', {
        extraName: extra.name,
        groupName: group.name,
      }),
    );
    if (removable) {
      await removeExtraFromGroup({
        variables: {
          product_id: productId,
          group_id: group.extra_group_id,
          extra_id: extra.extra_id,
        },
        // TODO: fix problem or write own apollo store updater
        refetchQueries: [
          {
            query: productCategoriesQuery,
            variables: {
              id: storeId,
              filter: 'ALL',
            },
          },
        ],
      });
    }
  }

  return (
    <RowContainer key={extra.extra_id} disabled={disabled}>
      <ExtraDetailsContainer onClick={onExtraChange}>
        <ExtraTitleContainer>
          <Checkbox checked={selected} disabled />
          <ExtraTitle>{extra.name}</ExtraTitle>
          <IconButton onClick={openEditModal} name="edit" />
          <IconButton onClick={removeProduct} name="trash" color="red" />
        </ExtraTitleContainer>
        <ExtraPrice>
          {formatPrice(extra.price_raw || extra.price, [], false, true)}
        </ExtraPrice>
      </ExtraDetailsContainer>
      {isEditModalOpen && (
        <ExtraEditModal
          onClose={closeEditModal}
          extra={extra}
          storeId={storeId}
          productId={productId}
        />
      )}
    </RowContainer>
  );
}

ExtraSelectItem.propTypes = {
  extra: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  storeId: PropTypes.string.isRequired,
};

export default ExtraSelectItem;
